export enum Presence {

    present = 'present',
    unavailable = 'unavailable',
    away = 'away',

}
